import { isObjEmpty } from "./objHelper";

export function validarCNPJ(cnpj: string): boolean {
  if (isObjEmpty(cnpj)) return false;

  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj.length !== 14) {
    return false;
  }

  let tamanhoTotal = cnpj.length - 2;
  let cnpjSemDigitos = cnpj.substring(0, tamanhoTotal);
  let digitosVerificadores = cnpj.substring(tamanhoTotal);
  let soma = 0;
  let pos = tamanhoTotal - 7;

  for (let i = tamanhoTotal; i >= 1; i--) {
    soma += parseInt(cnpjSemDigitos.charAt(tamanhoTotal - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  const resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitosVerificadores.charAt(0))) {
    return false;
  }

  tamanhoTotal = tamanhoTotal + 1;
  cnpjSemDigitos = cnpj.substring(0, tamanhoTotal);
  soma = 0;
  pos = tamanhoTotal - 7;

  for (let i = tamanhoTotal; i >= 1; i--) {
    soma += parseInt(cnpjSemDigitos.charAt(tamanhoTotal - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  const segundoResultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (segundoResultado !== parseInt(digitosVerificadores.charAt(1))) {
    return false;
  }

  return true;
}
